// @ts-nocheck
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_LOADING = "VERIFY_EMAIL_LOADING";
export const VERIFY_EMAIL_ERROR = "VERIFY_EMAIL_ERROR";
export const SEND_CODE_SUCCESS = "SEND_CODE_SUCCESS";
export const SEND_CODE_LOADING = "SEND_CODE_LOADING";
export const SEND_CODE_ERROR = "SEND_CODE_ERROR";
export const PREFERENCES_SUCCESS = "PREFERENCES_SUCCESS";
export const PREFERENCES_LOADING = "PREFERENCES_LOADING";
export const PREFERENCES_ERROR = "PREFERENCES_ERROR";
export const VERIFY_CODE_SUCCESS = "VERIFY_CODE_SUCCESS";
export const VERIFY_CODE_LOADING = "VERIFY_CODE_LOADING";
export const VERIFY_CODE_ERROR = "VERIFY_CODE_ERROR";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_LOADING = "USER_DETAILS_LOADING";
export const USER_DETAILS_ERROR = "USER_DETAILS_ERROR";
export const HISTORY_SUCCESS = "HISTORY_SUCCESS";
export const HISTORY_LOADING = "HISTORY_LOADING";
export const HISTORY_ERROR = "HISTORY_ERROR";
export const FEATURE_PREVIEWS_SUCCESS = "FEATURE_PREVIEWS_SUCCESS";
export const FEATURE_PREVIEWS_LOADING = "FEATURE_PREVIEWS_LOADING";
export const FEATURE_PREVIEWS_ERROR = "FEATURE_PREVIEWS_ERROR";
export const UPDATE_INTEREST_SUCCESS = "UPDATE_INTEREST_SUCCESS";
export const UPDATE_INTEREST_LOADING = "UPDATE_INTEREST_LOADING";
export const UPDATE_INTEREST_ERROR = "UPDATE_INTEREST_ERROR";
export const USAGE_STATS_SUCCESS = "USAGE_STATS_SUCCESS";
export const USAGE_STATS_LOADING = "USAGE_STATS_LOADING";
export const USAGE_STATS_ERROR = "USAGE_STATS_ERROR";
export const REQUIRED_LIST_SUCCESS = "REQUIRED_LIST_SUCCESS";
export const REQUIRED_LIST_LOADING = "REQUIRED_LIST_LOADING";
export const REQUIRED_LIST_ERROR = "REQUIRED_LIST_ERROR";
export const RECENT_LIST_SUCCESS = "RECENT_LIST_SUCCESS";
export const RECENT_LIST_LOADING = "RECENT_LIST_LOADING";
export const RECENT_LIST_ERROR = "RECENT_LIST_ERROR";
export const RELEASE_NOTES_LIST_SUCCESS = "RELEASE_NOTES_LIST_SUCCESS";
export const RELEASE_NOTES_LIST_LOADING = "RELEASE_NOTES_LIST_LOADING";
export const RELEASE_NOTES_LIST_ERROR = "RELEASE_NOTES_LIST_ERROR";
export const UPGRADE_REQUEST_SUCCESS = "UPGRADE_REQUEST_SUCCESS";
export const UPGRADE_REQUEST_LOADING = "UPGRADE_REQUEST_LOADING";
export const UPGRADE_REQUEST_ERROR = "UPGRADE_REQUEST_ERROR";
export const UPGRADE_REQUEST_LIST_SUCCESS = "UPGRADE_REQUEST_LIST_SUCCESS";
export const UPGRADE_REQUEST_LIST_LOADING = "UPGRADE_REQUEST_LIST_LOADING";
export const UPGRADE_REQUEST_LIST_ERROR = "UPGRADE_REQUEST_LIST_ERROR";
export const FEATURE_REQUEST_REQUIRED_LIST_SUCCESS = "FEATURE_REQUEST_REQUIRED_LIST_SUCCESS";
export const FEATURE_REQUEST_REQUIRED_LIST_LOADING = "FEATURE_REQUEST_REQUIRED_LIST_LOADING";
export const FEATURE_REQUEST_REQUIRED_LIST_ERROR = "FEATURE_REQUEST_REQUIRED_LIST_ERROR";
export const FEATURE_REQUEST_GET_LIST_SUCCESS = "FEATURE_REQUEST_GET_LIST_SUCCESS";
export const FEATURE_REQUEST_GET_LIST_LOADING = "FEATURE_REQUEST_GET_LIST_LOADING";
export const FEATURE_REQUEST_GET_LIST_ERROR = "FEATURE_REQUEST_GET_LIST_ERROR";
export const CONTACT_ADMIN_SUCCESS = "CONTACT_ADMIN_SUCCESS";
export const CONTACT_ADMIN_LOADING = "CONTACT_ADMIN_LOADING";
export const CONTACT_ADMIN_ERROR = "CONTACT_ADMIN_ERROR";
export const FEATURE_REQUEST_FEEDBACK_SUCCESS = "FEATURE_REQUEST_FEEDBACK_SUCCESS";
export const FEATURE_REQUEST_FEEDBACK_LOADING = "FEATURE_REQUEST_FEEDBACK_LOADING";
export const FEATURE_REQUEST_FEEDBACK_ERROR = "FEATURE_REQUEST_FEEDBACK_ERROR";
export const VOTE_SUCCESS = "VOTE_SUCCESS";
export const VOTE_LOADING = "VOTE_LOADING";
export const VOTE_ERROR = "VOTE_ERROR";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const UPDATE_SUPPORT_CONTACT_SUCCESS = "UPDATE_SUPPORT_CONTACT_SUCCESS";
export const UPDATE_SUPPORT_CONTACT_LOADING = "UPDATE_SUPPORT_CONTACT_LOADING";
export const UPDATE_SUPPORT_CONTACT_ERROR = "UPDATE_SUPPORT_CONTACT_ERROR";
export const CASE_REQUIRED_LIST_SUCCESS = "CASE_REQUIRED_LIST_SUCCESS";
export const CASE_REQUIRED_LIST_LOADING = "CASE_REQUIRED_LIST_LOADING";
export const CASE_REQUIRED_LIST_ERROR = "CASE_REQUIRED_LIST_ERROR";
export const CASE_LIST_SUCCESS = "CASE_LIST_SUCCESS";
export const CASE_LIST_LOADING = "CASE_LIST_LOADING";
export const CASE_LIST_ERROR = "CASE_LIST_ERROR";
export const CASE_COMMENTS_LIST_SUCCESS = "CASE_COMMENTS_LIST_SUCCESS";
export const CASE_COMMENTS_LIST_LOADING = "CASE_COMMENTS_LIST_LOADING";
export const CASE_COMMENTS_LIST_ERROR = "CASE_COMMENTS_LIST_ERROR";
export const CASE_COMMENTS_ADD_SUCCESS = "CASE_COMMENTS_ADD_SUCCESS";
export const CASE_COMMENTS_ADD_LOADING = "CASE_COMMENTS_ADD_LOADING";
export const CASE_COMMENTS_ADD_ERROR = "CASE_COMMENTS_ADD_ERROR";
export const CASE_COMMENTS_ADD_REPLY_SUCCESS = "CASE_COMMENTS_ADD_REPLY_SUCCESS";
export const CASE_COMMENTS_ADD_REPLY_LOADING = "CASE_COMMENTS_ADD_REPLY_LOADING";
export const CASE_COMMENTS_ADD_REPLY_ERROR = "CASE_COMMENTS_ADD_REPLY_ERROR";
export const CASE_UPLOAD_FILE_SUCCESS = "CASE_UPLOAD_FILE_SUCCESS";
export const CASE_UPLOAD_FILE_LOADING = "CASE_UPLOAD_FILE_LOADING";
export const CASE_UPLOAD_FILE_ERROR = "CASE_UPLOAD_FILE_ERROR";
export const CASE_CREATE_SUCCESS = "CASE_CREATE_SUCCESS";
export const CASE_CREATE_LOADING = "CASE_CREATE_LOADING";
export const CASE_CREATE_ERROR = "CASE_CREATE_ERROR";
export const CASE_CLOSE_SUCCESS = "CASE_CLOSE_SUCCESS";
export const CASE_CLOSE_LOADING = "CASE_CLOSE_LOADING";
export const CASE_CLOSE_ERROR = "CASE_CLOSE_ERROR";
export const CHANGE_REQUEST_REQUIRED_LIST_SUCCESS = "CHANGE_REQUEST_REQUIRED_LIST_SUCCESS";
export const CHANGE_REQUEST_REQUIRED_LIST_LOADING = "CHANGE_REQUEST_REQUIRED_LIST_LOADING";
export const CHANGE_REQUEST_REQUIRED_LIST_ERROR = "CHANGE_REQUEST_REQUIRED_LIST_ERROR";
export const CHANGE_REQUEST_LIST_SUCCESS = "CHANGE_REQUEST_LIST_SUCCESS";
export const CHANGE_REQUEST_LIST_LOADING = "CHANGE_REQUEST_LIST_LOADING";
export const CHANGE_REQUEST_LIST_ERROR = "CHANGE_REQUEST_LIST_ERROR";
export const CHANGE_REQUEST_COMMENTS_LIST_SUCCESS = "CHANGE_REQUEST_COMMENTS_LIST_SUCCESS";
export const CHANGE_REQUEST_COMMENTS_LIST_LOADING = "CHANGE_REQUEST_COMMENTS_LIST_LOADING";
export const CHANGE_REQUEST_COMMENTS_LIST_ERROR = "CHANGE_REQUEST_COMMENTS_LIST_ERROR";
export const CHANGE_REQUEST_COMMENTS_ADD_SUCCESS = "CHANGE_REQUEST_COMMENTS_ADD_SUCCESS";
export const CHANGE_REQUEST_COMMENTS_ADD_LOADING = "CHANGE_REQUEST_COMMENTS_ADD_LOADING";
export const CHANGE_REQUEST_COMMENTS_ADD_ERROR = "CHANGE_REQUEST_COMMENTS_ADD_ERROR";
export const CHANGE_REQUEST_COMMENTS_ADD_REPLY_SUCCESS = "CHANGE_REQUEST_COMMENTS_ADD_REPLY_SUCCESS";
export const CHANGE_REQUEST_COMMENTS_ADD_REPLY_LOADING = "CHANGE_REQUEST_COMMENTS_ADD_REPLY_LOADING";
export const CHANGE_REQUEST_COMMENTS_ADD_REPLY_ERROR = "CHANGE_REQUEST_COMMENTS_ADD_REPLY_ERROR";
export const CHANGE_REQUEST_UPLOAD_FILE_SUCCESS = "CHANGE_REQUEST_UPLOAD_FILE_SUCCESS";
export const CHANGE_REQUEST_UPLOAD_FILE_LOADING = "CHANGE_REQUEST_UPLOAD_FILE_LOADING";
export const CHANGE_REQUEST_UPLOAD_FILE_ERROR = "CHANGE_REQUEST_UPLOAD_FILE_ERROR";
export const CHECK_PACKAGE_VERSION_SUCCESS = "CHECK_PACKAGE_VERSION_SUCCESS";
export const CHECK_PACKAGE_VERSION_LOADING = "CHECK_PACKAGE_VERSION_LOADING";
export const CHECK_PACKAGE_VERSION_ERROR = "CHECK_PACKAGE_VERSION_ERROR";
export const REQUEST_HELP_SUCCESS = "REQUEST_HELP_SUCCESS";
export const REQUEST_HELP_LOADING = "REQUEST_HELP_LOADING";
export const REQUEST_HELP_ERROR = "REQUEST_HELP_ERROR";
export const LICENSE_LIST_SUCCESS = "LICENSE_LIST_SUCCESS";
export const LICENSE_LIST_LOADING = "LICENSE_LIST_LOADING";
export const LICENSE_LIST_ERROR = "LICENSE_LIST_ERROR";
export const LICENSE_ADJUSTMENT_SUCCESS = "LICENSE_ADJUSTMENT_SUCCESS";
export const LICENSE_ADJUSTMENT_LOADING = "LICENSE_ADJUSTMENT_LOADING";
export const LICENSE_ADJUSTMENT_ERROR = "LICENSE_ADJUSTMENT_ERROR";
export const VALIDATE_LOGIN_SUCCESS = "VALIDATE_LOGIN_SUCCESS";
export const VALIDATE_LOGIN_LOADING = "VALIDATE_LOGIN_LOADING";
export const VALIDATE_LOGIN_ERROR = "VALIDATE_LOGIN_ERROR";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_LOADING = "PRODUCT_LIST_LOADING";
export const PRODUCT_LIST_ERROR = "PRODUCT_LIST_ERROR";
export const CREATE_ENGAGEMENT_SUCCESS = "CREATE_ENGAGEMENT_SUCCESS";
export const CREATE_ENGAGEMENT_LOADING = "CREATE_ENGAGEMENT_LOADING";
export const CREATE_ENGAGEMENT_ERROR = "CREATE_ENGAGEMENT_ERROR";